/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const memberInputSchema = z.object({
  email: z.string().nullish(),
  name: z.string().min(1),
});
